module.exports = __webpack_public_path__ + "img/img_banner_inter.9554e6dd.png";